import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _SelectTrigger;
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@crehana/compass.ui/v2";
import cn from "clsx";
import useNewDashboardTranslations from "../../../../hooks/useNewDashboardTranslations";
import { getByLabelText, redirectToProductDashboard } from "./utils";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
var ProductSidebar = function ProductSidebar(_ref) {
  var isDark = _ref.isDark,
    sidebarCollapsed = _ref.sidebarCollapsed,
    isProduction = _ref.isProduction;
  var _useNewDashboardTrans = useNewDashboardTranslations(),
    t = _useNewDashboardTrans.t;
  var _React$useState = React.useState('learning'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedProduct = _React$useState2[0],
    setSelectedProduct = _React$useState2[1];

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (sidebarCollapsed) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: cn('tw-px-2 py-20 border-solid border-b mb-8 tw-relative tw-z-7', isDark ? 'border-base-lighter-16' : 'border-gray-lighter'),
    children: [/*#__PURE__*/_jsxs("p", {
      className: "mb-8 tw-font-subtitle5",
      children: [t('PRODUCT'), ":"]
    }), /*#__PURE__*/_jsxs(Select, {
      value: selectedProduct,
      onValueChange: function onValueChange(value) {
        setSelectedProduct(value);
        redirectToProductDashboard({
          product: value,
          isProduction: isProduction
        });
      },
      children: [_SelectTrigger || (_SelectTrigger = /*#__PURE__*/_jsx(SelectTrigger, {
        className: "tw-px-1 tw-gap-0.2",
        children: /*#__PURE__*/_jsx(SelectValue, {})
      })), /*#__PURE__*/_jsxs(SelectContent, {
        children: [/*#__PURE__*/_jsx(SelectItem, {
          value: "learning",
          children: getByLabelText('learning')
        }), /*#__PURE__*/_jsx(SelectItem, {
          value: "talent",
          children: getByLabelText('talent')
        })]
      })]
    })]
  });
};
export default ProductSidebar;